//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Swiper from './components/vue-swiper'
export default {
    name: 'App',
    data() {
        return {
            "basic": {
                "city": "",
                "update": { "loc": "" }
            },
            "now": {
                "hum": "",
                "fl": "",
                "vis": "",
                "wind": {},
                "cond": {
                    "txt": ''
                }
            },
            "chartsOptions": {
            },
            "daily_forecast": [],
            "afterCalculater": {
                "maxTmps": [],
                "minTmps": [],
                "xDate": []
            },
            "cool": {
                "oldLocation": 0
            }
        }
    },
    components: { Swiper },
    mounted() {
        return this.getWeathers();
    },
    methods: {
        view({ title, description, keywords }) {
            if (title) {
                document.title = title
            }
            if (description) {
                document.head.querySelector('meta[name=description]').content = description
            }
            if (keywords) {
                document.head.querySelector('meta[name=keywords]').content = keywords
            }
        },
        getWeathers: function () {
            let self = this
            self.$http.get('/now').then(response => {
                self.now = response.data.HeWeather5[0].now;
                self.basic = response.data.HeWeather5[0].basic;
            }).catch(error => {
                throw new Error(error);
            })

            self.$http.get('/forecast').then(response => {
                self.daily_forecast = response.data.HeWeather5[0].daily_forecast;
            }).then(() => {
                self.calcuTems(self.daily_forecast)
            }).then(() => {
                self.renderCharts();
            }).catch(error => {
                throw new Error(error);
            })
            console.log('GetWeathers')
        },
        calcuTems: function (temArr) {
            let [temMaxs, temMins, xDate] = [[], [], []];
            temArr.forEach((item, i) => {
                temMaxs.push(item.tmp.max);
                temMins.push(item.tmp.min);
                xDate.push(i == 0 ? '今天' : Number(item.date.split('-')[1]) + '-' + Number(item.date.split('-')[2]));

            })
            this.afterCalculater = { maxTmps: temMaxs, minTmps: temMins, xDate: xDate };
            console.log(temMaxs, temMins);
        },
        onSlideChangeStart: function (currentPage) {
            console.log('onSlideChangeStart', currentPage);
            if (currentPage === 1) {
                this.cool.oldLocation = 0;
            } else {
                this.cool.oldLocation = parseInt(window.screen.height / 3)
            }
        },
        formatTime: function (timeString) {
            return Number(timeString.split(' ')[0].split('-')[1]) + '月' + Number(timeString.split(' ')[0].split('-')[2]) + '日'
        },
        startFreshPlay: function () {
            this.svgRun()
            this.getWeathers()
        },
        svgRun: function () {
            let path = document.querySelector('.refresh path');
            let length = path.getTotalLength();
            path.style.transition = path.style.WebkitTransition = 'none';
            path.style.strokeDasharray = length + ' ' + length;
            path.style.strokeDashoffset = length;

            path.getBoundingClientRect();
            path.style.transition = path.style.WebkitTransition = 'stroke-dashoffset 2s ease-in-out';
            path.style.strokeDashoffset = '0';
        },
        renderCharts: function () {
            let self = this;
            let myChart = this.$echarts.init(document.getElementById('tem-chart'));
            myChart.setOption({
                "xAxis": {
                    "type": 'category',
                    "boundaryGap": false,
                    "data": self.afterCalculater.xDate
                },
                "yAxis": {
                    "show": false,
                    "type": 'value',
                    "min": 'dataMin',
                    "max": 'dataMin',
                    "axisLabel": {
                        "formatter": '{value} °C'
                    }
                },
                "series": [
                    {
                        "name": '最高气温',
                        "type": 'line',
                        "lineStyle": {
                            "normal": {
                                "width": 1,
                                "color": '#f04134',
                                "type": 'solid'
                            }
                        },
                        "data": self.afterCalculater.maxTmps,
                        "markLine": {
                            "data": [
                                { "type": 'average', "name": '平均值' }
                            ]
                        }
                    }, {
                        "name": '最低气温',
                        "type": 'line',
                        "lineStyle": {
                            "normal": {
                                "width": 1,
                                "color": '#7265e6',
                                "type": 'solid'
                            }
                        },
                        "data": self.afterCalculater.minTmps,
                        "markLine": {
                            "data": [
                                { "type": 'average', "name": '平均值' },
                            ]
                        }
                    }
                ]
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/App.vue